export const en = {
    'default-error': 'Data entered incorrectly'
};
